/**
 * Feedback: labels for what the backend stores.
 *
 * Stored values (category, status, module) are fixed by the backend —
 * r-point modules/v1/shared/feedback/feedback.modules.js — and never renamed.
 * Labels are ours; category wording matches the GIS web apps so an admin reads
 * exactly what the user picked.
 */

export const PRODUCTS = {
    rpoint: {
        title: "R-Point Feedback",
        permission: "feedback_rpoint",
        // Where "Open in map" points. Unset, the link is hidden.
        gisWebUrl: process.env.REACT_APP_RPOINT_GIS_WEB_URL,
    },
    mep: {
        title: "MyEstatePoint Feedback",
        permission: "feedback_mep",
        gisWebUrl: process.env.REACT_APP_MEP_GIS_WEB_URL,
    },
};

export const MODULE_LABELS = {
    gis: "GIS maps",
};

export const CATEGORY_LABELS = {
    missing_or_outdated: "Map is missing or outdated",
    misalignment: "Map isn't aligned",
    visibility: "Map isn't clearly visible",
    other: "Other issue",
    suggestion: "Suggestion",
};

export const STATUSES = [
    { value: "new", label: "New", bg: "primary" },
    { value: "in_progress", label: "In progress", bg: "warning" },
    { value: "resolved", label: "Resolved", bg: "success" },
    { value: "wont_fix", label: "Won't fix", bg: "secondary" },
];

export const statusMeta = (value) =>
    STATUSES.find((s) => s.value === value) || { value, label: value || "-", bg: "light" };

export const PLATFORM_LABELS = { web: "Web", android: "Android", ios: "iOS" };
